<template>

    <Head>
        <title>Buscador</title>
    </Head>
    <div class="hero-img-overlay hero-lila" style="background-image: url(/img/hero-dif.png);">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h1 class="hero-encabezado">Buscador</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="contenido-wrapper">

        <!--Conoce los diferentes trámites y servicios que ofrece el DIF municipal de Santiago-->
        <div class="bloque-general bloque-tarjetas-dif">
            <div class="container">
                <div class="row" style="align-items: end;">

                    <div class="col-md-4">
                        <div class="bloque-filtro">
                            <div class="bloque-filtro__encabezado">¿Qué estas buscado?</div>
                            <div class="form-group" :class="(search == '') ? 'not-valid' : ''">
                                <input class="form-control input-buscador" v-model="search" type="text" placeholder="">
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="bloque-filtro">
                            <div class="bloque-filtro__encabezado">¿En qué categoría?</div>
                            <div class="form-group" :class="(categoria == '') ? 'not-valid' : ''">
                                <select v-model="categoria" class="form-control form__select">
                                    <option value="" selected disabled>Selecciona una categoría</option>
                                    <option value="tramites-servicios">Trámites y Servicios</option>
                                    <option value="noticias">Noticias</option>
                                    <option value="eventos">Eventos</option>
                                    <option value="programas">Programas</option>
                                    <option value="directorio-municipal">Directorio Municipal</option>
                                    <option value="centros-dif">Centros DIF</option>
                                    <option value="lugares-interes">Lugares de Interés</option>
                                    <option value="dependencias">Dependencias Municipales</option>
                                    <option value="titulares-dependencias">Titulares de las Dependencias</option>
                                    <option value="comisiones">Comisiones</option>
                                    <option value="marco-normativo">Marco Normativo</option>
                                    <optgroup label="Mejora Regulatoria">
                                        <option value="mejora-programa">Programa Anual de Mejora Regulatoria</option>
                                        <option value="mejora-analisis">Análisis de Impacto Regulatorio</option>
                                        <option value="mejora-agenda">Agenda Regulatoria</option>
                                        <option value="mejora-inspecciones">Listado de inspecciones y verificaciones</option>
                                        <option value="mejora-padron">Padrón de Inspectores y Verificadores</option>
                                        <option value="mejora-normativa">Normativa para la Mejora Regulatoria</option>
                                    </optgroup>
                                </select>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-4">
                        <div class="bloque-filtro">
                            <button class="boton-secundario boton-flecha" type="normal" @click="buscando()">Buscar</button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="tramites-servicios__listado">

                            <div class="busqueda-item" v-for="(item, index) in items.data" :key="index">

                                <div v-if="cate == 'noticias'">
                                    <div class="tramite-servicio-item__secretaria mb-2">{{ $filters.getFullDate(item.created_at) }}</div>
                                    <h4 class="busqueda-item__titulo">
                                        <Link :href="'/noticia/' + item.slug">{{ item.titulo }}</Link>
                                    </h4>
                                    <div class="busqueda-descripcion"> {{ $filters.truncate(item.raw, 200, '...') }}</div>
                                    <Link :href="'/noticia/' + item.slug" class="tarjeta-noticia__link">Ver noticia</Link>
                                </div>

                                <div v-if="cate == 'eventos'">
                                    <div class="tramite-servicio-item__secretaria mb-2">
                                        {{ $filters.getFullDate(item.fecha_desde) }}
                                        <span class="separador" v-if="item.fecha_desde != item.fecha_hasta">- </span>
                                        <span v-if="item.fecha_desde != item.fecha_hasta">{{ $filters.getFullDate(item.fecha_hasta) }}</span>
                                    </div>
                                    <h4 class="busqueda-item__titulo">
                                        <Link :href="'/evento/' + item.slug">{{ item.nombre }}</Link>
                                    </h4>
                                    <div class="busqueda-descripcion"> {{ $filters.truncate(item.raw, 200, '...') }}</div>
                                    <Link :href="'/evento/' + item.slug" class="tarjeta-noticia__link">Ver evento</Link>
                                </div>

                                <div v-if="cate == 'directorio-municipal'">
                                    <h4 class="busqueda-item__titulo">
                                        <Link :href="'/gobierno-municipal/directorio'">{{ item.departamento }}</Link>
                                    </h4>
                                    <div class="busqueda-descripcion">{{ item.lugar }}</div>
                                    <div v-if="item.otros != ''" class="busqueda-descripcion" v-html="item.otros"></div>
                                </div>

                                <div v-if="cate == 'dependencias'">
                                    <h4 class="busqueda-item__titulo">
                                        <Link :href="'/gobierno-municipal/dependencias-municipales'">{{ item.nombre }}</Link>
                                    </h4>
                                    <div class="busqueda-descripcion"><strong>Titular:</strong> {{ item.secretario }}</div>
                                </div>

                                <div v-if="cate == 'titulares-dependencias'">
                                    <h4 class="busqueda-item__titulo">
                                        <Link :href="'/gobierno-municipal/titulares-dependencias'">{{ item.secretaria.nombre }}</Link>
                                    </h4>
                                    <div class="busqueda-descripcion"><strong>Titular:</strong> {{ item.nombre }}</div>
                                    <div class="busqueda-descripcion">{{ item.cargo }}</div>
                                </div>

                                <div v-if="cate == 'comisiones'">
                                    <h4 class="busqueda-item__titulo">
                                        <Link :href="'/gobierno-municipal/comisiones'">{{ item.nombre }}</Link>
                                    </h4>
                                    <div class="busqueda-descripcion"><strong>Presidente:</strong> {{ item.presidente }}</div>
                                    <div class="busqueda-descripcion"><strong>Titular:</strong> {{ item.secretario }}</div>
                                    <div class="busqueda-descripcion"><strong>Vocal:</strong> {{ item.vocal }}</div>
                                </div>

                                <div v-if="cate == 'lugares-interes'">
                                    <div class="tramite-servicio-item__secretaria mb-2">{{ item.categoria.nombre }}</div>
                                    <h4 class="busqueda-item__titulo">
                                        <Link :href="'/turismo/lugares-interes'">{{ item.nombre }}</Link>
                                    </h4>
                                    <div class="busqueda-descripcion"> {{ $filters.truncate(item.informacion, 200, '...') }}</div>
                                </div>

                                <div v-if="cate == 'centros-dif'">
                                    <h4 class="busqueda-item__titulo">
                                        <Link :href="'/dif/centros-dif'">{{ item.nombre }}</Link>
                                    </h4>
                                    <div class="busqueda-descripcion">{{ item.direccion }}</div>
                                    <div class="busqueda-descripcion">{{ item.telefono }}</div>
                                </div>

                                <div v-if="cate == 'tramites-servicios'">
                                    <span v-if="item.enlinea == 1" class="badge etiqueta-simple mb-2">En Línea</span>
                                    <span v-if="item.presencial == 1" class="badge etiqueta-simple mb-2">Presencial</span>
                                    <div class="tramite-servicio-item__secretaria mb-2">{{ item.secretaria.nombre }}</div>
                                    <h4 class="busqueda-item__titulo mb-2">
                                        <Link :href="'/servicio/' + item.slug">{{ item.nombre }}</Link>
                                    </h4>
                                    <div class="busqueda-descripcion"> {{ $filters.truncate(item.raw, 500, '...') }}</div>
                                    <Link :href="'/servicio/' + item.slug" class="tarjeta-noticia__link">Ver más</Link>
                                </div>

                                <div v-if="cate == 'programas'">
                                    <span v-if="item.enlinea == 1" class="badge etiqueta-simple mb-2">En Línea</span>
                                    <span v-if="item.presencial == 1" class="badge etiqueta-simple mb-2">Presencial</span>
                                    <div class="tramite-servicio-item__secretaria mb-2">{{ item.secretaria.nombre }}</div>
                                    <h4 class="busqueda-item__titulo mb-2">
                                        <Link :href="'/programa/' + item.slug">{{ item.nombre }}</Link>
                                    </h4>
                                    <div class="busqueda-descripcion"> {{ $filters.truncate(item.raw, 200, '...') }}</div>
                                    <Link :href="'/programa/' + item.slug" class="tarjeta-noticia__link">Ver más</Link>
                                </div>

                                <div v-if="cate == 'marco-normativo'">
                                    <div class="tramite-servicio-item__secretaria mb-2">{{ item.categoria.nombre }}</div>
                                    <h3 class="busqueda-item__titulo m-0 mb-2">
                                        {{ item.nombre }}
                                    </h3>
                                    <a v-if="item.link != null && item.file == null" :href="'http://mirror.santiago.gob.mx/' + item.link" target="_blank" class="boton-secundario boton-flecha">Descargar</a>
                                    <a v-if="item.file != null" :href="'https://www.santiago.gob.mx/storage/' + decodeURIComponent(item.file)" target="_blank" class="boton-secundario boton-flecha">Descargar</a>
                                </div>

                                <!-- Mejora Programa -->
                                <div v-if="cate == 'mejora-programa'">
                                    <h4 class="busqueda-item__titulo m-0">
                                        {{ item.year }} - {{ item.nombre }}
                                    </h4>
                                    <a :href="route('programa.download', item.id) + '?' + Math.ceil(Math.random() * 1000000)" style="margin-top:10px;" target="_blank" class="boton-secundario boton-flecha">Descargar</a>
                                </div>

                                <!-- Mejora Analisis -->
                                <div v-if="cate == 'mejora-analisis'">
                                    <div class="tramite-servicio-item__secretaria">{{ item.tipo }}</div>
                                    <h4 class="busqueda-item__titulo m-0">
                                        {{ item.year }} - {{ item.nombre }}
                                    </h4>
                                    <a :href="route('analisis.download', item.id) + '?' + Math.ceil(Math.random() * 1000000)" style="margin-top:10px;" target="_blank" class="boton-secundario boton-flecha">Descargar</a>
                                </div>

                                <!-- Mejora Agenda Regulatoria -->
                                <div v-if="cate == 'mejora-agenda'">
                                    <div class="tramite-servicio-item__secretaria">{{ item.secretaria.nombre }}</div>
                                    <h3 class="busqueda-item__titulo m-0">
                                        {{ item.nombre }}
                                    </h3>
                                    <div class="busqueda-descripcion"><strong>Período:</strong> {{ item.periodo }}</div>
                                    <div class="busqueda-descripcion"><strong>Acción:</strong> {{ item.accion }}</div>
                                    <a :href="route('agenda.download', item.id) + '?' + Math.ceil(Math.random() * 1000000)" style="margin-top:10px;" target="_blank" class="boton-secundario boton-flecha">Descargar</a>
                                </div>

                                <!-- Mejora Listado de inspecciones y verificaciones -->
                                <div v-if="cate == 'mejora-inspecciones'">
                                    <div class="tramite-servicio-item__secretaria">{{ item.secretaria.nombre }}</div>
                                    <h4 class="busqueda-item__titulo m-0">
                                        {{ item.nombre }}
                                    </h4>

                                    <div class="tipo" style="display: flex;">
                                        <div v-if="item.tipo === 'Inspección'">
                                            <img src="/img/mejora/icon_analisis.png" alt="" />
                                        </div>
                                        <span v-else-if="item.tipo === 'Verificación'">
                                            <font-awesome-icon icon="fa-solid fa-file-alt" class="mr-1" />
                                        </span>
                                        <span v-else="item.tipo === 'Visita'">
                                            <font-awesome-icon icon="fa-solid fa-house" class="mr-1" />
                                        </span>
                                        <span style="margin-left:5px;">{{ item.tipo }}</span>
                                    </div>
                                    <a :href="route('inspecciones.download', item.id) + '?' + Math.ceil(Math.random() * 1000000)" style="margin-top:10px;" target="_blank" class="boton-secundario boton-flecha">Descargar</a>
                                </div>

                                <!-- Mejora Padrón de Inspectores y Verificadores -->
                                <div v-if="cate == 'mejora-padron'">
                                    <div class="tramite-servicio-item__secretaria">{{ item.secretaria.nombre }}</div>
                                    <h3 class="busqueda-item__titulo m-0 font-weight-bold">
                                        {{ item.nombre }}
                                    </h3>
                                    <div class="busqueda-descripcion"><strong>Puesto:</strong> {{ item.puesto }}</div>
                                    <div class="busqueda-descripcion"><strong>Cargo:</strong> {{ item.cargo }}</div>
                                    <div class="busqueda-descripcion"><strong>Folio:</strong> {{ item.folio }}</div>
                                    <div class="busqueda-descripcion"><strong>Horario:</strong> {{ item.horario }}</div>
                                    <div class=" font-weight-bold">Vigencia del cargo materia: <span class="font-weight-normal">{{ $filters.getDate(item.vigencia) }}</span></div>
                                    <div class=" font-weight-bold">Giro de la inspección o verificación: <span class="font-weight-normal">{{ item.giro }}</span></div>
                                    <div class=" font-weight-bold">Jefe inmediato: <span class="font-weight-normal">{{ item.jefe_inmediato }}</span></div>
                                    <div class=" font-weight-bold">Cargo del jefe inmediato: <span class="font-weight-normal">{{ item.cargo }}</span></div>
                                    <div class=" font-weight-bold">Fundamento jurídico de la inspección o verificación: <span class="font-weight-normal">{{ item.fundamento }}</span></div>
                                </div>

                                <!-- Mejora Normativa para la Mejora Regulatoria -->
                                <div v-if="cate == 'mejora-normativa'">
                                    <div class="tramite-servicio-item__secretaria">{{ item.secretaria.nombre }}</div>
                                    <h3 class="busqueda-item__titulo m-0">
                                        {{ item.nombre }}
                                    </h3>
                                    <a :href="route('normativa.download', item.id) + '?' + Math.ceil(Math.random() * 1000000)" style="margin-top:10px;" target="_blank" class="boton-secundario boton-flecha">Descargar</a>
                                </div>

                            </div>

                        </div>
                        <div v-if="items.data?.length < 1 && vars">
                            <NoResults />
                        </div>
                        <div v-if="!vars">
                            <div class="alert alert-danger alert-dismissible fade show" role="alert">
                                <img loading="lazy" width="20" height="18" src="/img/icono-advertencia-blanco.svg" alt="Alerta">
                                <span>Proporciona lo que estas buscando y la categoría</span>
                            </div>
                        </div>
                        <div class="row" v-if="items.total > limit">
                            <div class="col-12">
                                <Paginacion :links="items.links" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import NoResults from "../../Shared/Utils/NoResults.vue";
import { Link } from '@inertiajs/inertia-vue3'
import { Inertia } from '@inertiajs/inertia'
import Paginacion from '../../Shared/Paginacion.vue'

export default {
    props: {
        buscar: String,
        cate: String,
        limit: Number,
        items: Object,
        vars: Boolean,
    },
    data() {
        return {
            search: this.buscar || '',
            categoria: this.cate || ''
        }
    },
    components: {
        NoResults, Link, Paginacion
    },
    computed: {
    },
    methods: {
        buscando: function () {
            Inertia.get('/buscador',
                {
                    buscar: this.search,
                    categoria: this.categoria,
                },
                {
                    preserveState: true,
                    preserveScroll: true,
                    replace: true
                }
            )
        },
    },
}
</script>
<style scoped>
.tramites-servicios__listado .tramite-servicio-item__info {
    max-width: 100%;
}

.hero-img-overlay.hero-lila {
    padding-top: 28px;
    padding-bottom: 28px;
}

.contenido-wrapper {
    padding-top: 50px;
}

.tramites-servicios__listado .tramite-servicio-item {
    display: block;
}

.tarjeta-noticia__link {
    border: 0;
}

.busqueda-item h4 {
    margin: 0;
}

.form-group.not-valid select {
    border-color: #CD1518;
}


.boton-secundario {
    padding: 5px 10px;
    font-size: 15px;
}

h2 {
    line-height: 1.3em;
}

@media (max-width: 576px) {
    .nombre {
        display: block;
        width: 350px;
    }

    .boton {
        display: block;
        padding-top: 0px;
    }
}
</style>
